import * as tslib_1 from "tslib";
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { environment } from '../../../../environments/environment';
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs/index";
var KraftpaketService = /** @class */ (function (_super) {
    tslib_1.__extends(KraftpaketService, _super);
    function KraftpaketService(http) {
        var _this = _super.call(this, http, {
            baseUrl: "" + environment.apiHost,
            path: 'makpak/mporigin'
        }) || this;
        _this.http = http;
        return _this;
    }
    KraftpaketService.prototype.getTeilpakete = function () {
        console.log("alle Teilpakete auslesen!");
        return _super.prototype.get.call(this, '/tpaket').pipe(map(function (res) {
            return res;
        }));
    };
    KraftpaketService.prototype.getTeilpaketeFiltered = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("aktuellste Teilpakete auslesen für angemeldeten User");
                        return [4 /*yield*/, this.http.get("" + environment.apiHost + '/makpak/mporiginfiltered').toPromise()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    KraftpaketService.prototype.getLatestTeilpaketHist = function (paketid) {
        console.log("aktuellste Teilpaketdetails auslesen für id: " + paketid);
        return this.http.get("" + environment.apiHost + '/makpak/mphistpaketid/' + paketid).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    KraftpaketService.prototype.sendIdInUse = function (paketid) {
        console.log("problem place after upload file: " + paketid);
        return this.http.get("" + environment.apiHost + '/makpak/sendId/' + paketid).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    KraftpaketService.prototype.deleteTeilPaket = function (mpOriginId) {
        console.log("Löschen eines Teilpakets - " + mpOriginId);
        return this.http.delete("" + environment.apiHost + '/makpak/mporm/' + mpOriginId, { withCredentials: true }).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
            console.log(result);
        })) /* */;
    };
    KraftpaketService.prototype.updateTeilpaket = function (teilpaketKraft) {
        console.log("Teilpaket aktualisieren");
        var formData = new FormData();
        formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
        return this.http.post("" + environment.apiHost + '/makpak/mporiginupdate', formData, { withCredentials: true }).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    KraftpaketService.prototype.updateTeilpaketStatus = function (mpOriginId, mpNewStatus, bensl) {
        console.log("Status des Teilpaket aktualisieren");
        var formData = new FormData();
        formData.append("mpOriginId", mpOriginId);
        formData.append("mpOriginNewStatus", mpNewStatus);
        formData.append("bensl", bensl);
        return this.http.post("" + environment.apiHost + '/makpak/mporiginupdatestatus', formData, { withCredentials: true }).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    return KraftpaketService;
}(RESTService));
export { KraftpaketService };
